module.exports = fox._r("images/post-placeholder.gif", __webpack_public_path__ + "images/post-placeholder.gif");


//////////////////
// WEBPACK FOOTER
// ./images/post-placeholder.gif
// module id = 27
// module chunks = 4